import styled from "styled-components";

import { ClipLoaderCommon } from "./LoaderCommon";
import { theme } from "@utilities";
import { Z_INDEX } from "@constants";

export const LoadingCommon = () => {
    return (
        <StyledLoading>
            <ClipLoaderCommon color={theme.colors.highlight} size={70} margin={150} />
        </StyledLoading>
    );
};

const StyledLoading = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: ${Z_INDEX.LOADING};

    img {
        width: 70px;
        height: 70px;
    }
`;
